import { LocationLookupItemAdditionalData, SystemName, isOrderType } from "@sal/onevent-portal";
import { EMPTY_STRING } from ".";
import { BLLFreightConsignment } from "../models";

const orderEntryStatusSystemNames = ["Quote", "Draft"];
const containerNumberFieldName = "Container Number";

export const addLookupAddress = (additionalData: LocationLookupItemAdditionalData) => {
	if (!additionalData) {
		return "";
	}

	const address = [
		additionalData?.address1,
		additionalData?.address2,
		additionalData?.suburb,
		additionalData?.postcode
	]
		.filter((part) => part !== null && part !== "")
		.join(", ");

	return address;
};

export const generateURL = (jobTypeSystemName: string, id: number | string, statusSystemName: string) => {
	const bookingPageStatusSystemNames = ["Quote", "Draft"];
	return `/${jobTypeSystemName.replace(/Consignment$/g, "")}${bookingPageStatusSystemNames.includes(statusSystemName) ? "Booking" : EMPTY_STRING}/${id}`;
};

export const getDisplayReference = (consignment?: Partial<Pick<BLLFreightConsignment, "reference" | "displayReference">>) =>
	consignment?.displayReference ?? consignment?.reference;

export const generateContainerTransportURL = (
	objectType: string,
	objectID: number | string,
	statusSystemName: string,
	matchedString?: string,
	containerID?: number | string
): string | undefined => {
	// Draft/Quote orders redirect to the order entry page.
	if (orderEntryStatusSystemNames.includes(statusSystemName)) {
		return `/Order/${objectID}?orderType=${objectType}`;
	}

	// A container number match navigates to the container tracking page.
	if (matchedString === containerNumberFieldName && containerID) {
		if (isOrderType("Import", objectType)) {
			return `/ImportContainer/${containerID}`;
		} else if (isOrderType("Export", objectType)) {
			return `/ExportContainer/${containerID}`;
		} else if (isOrderType("Move", objectType)) {
			return `/MoveContainer/${containerID}`;
		}
		return undefined;
	}

	// Otherwise navigate to the order tracking page.
	switch (objectType) {
		case SystemName.JobType.ImportFCLTransportOrder:
		case SystemName.JobType.ExportFCLTransportOrder:
		case SystemName.JobType.MoveTransportOrder:
			return `/${objectType}/${objectID}`;
		default:
			return undefined;
	}
};
